// Where "Contact support" messages go. Update if support moves to a different inbox.
export const SUPPORT_EMAIL = 'hello@getstudiotime.com';
